import * as type from './type'
import { get } from '../../../util/api'
import { loginSuccess } from '../../security/state/auth/action'
import { setStoreList } from '../../store/util/renderStoreName'

export const initGlobals = (globals) => dispatch => {
    if (!globals) {
        return
    }
    dispatch({
        type: type.INIT_GLOBALS,
        payload: {
            globals,
        },
    })

    setStoreList(globals.storeList)

    if (globals.user) {
        dispatch(loginSuccess(globals.user))
        delete globals.user
    }
}


export const loadGlobals = () => (dispatch) => {
    get('/api/globals/get')
        .then(globals => {
            dispatch(initGlobals(globals))
        })
}



// WEBPACK FOOTER //
// ./src/modules/globals/state/action.js